﻿import React from 'react';

import { OverlayTriggerType } from 'react-bootstrap/esm/OverlayTrigger';

import 'components/ToolTip/toolTip.scss';

import { OverlayTrigger, Popover } from 'react-bootstrap';
import { Placement } from 'react-bootstrap/esm/types';

interface ToolTipProps {
    className?: string;
    content: any;
    iconClassname?: string;
    placement?: Placement;
    tooltipColor?: string;
    trigger?: OverlayTriggerType;
}

export function ToolTip({
    className,
    content,
    iconClassname,
    placement = 'right',
    tooltipColor = '#007AC9',
    trigger = 'click',
    ...otherProps
}: ToolTipProps) {

    const popover = (
        <Popover id="popover-basic">
            <Popover.Body>
                {content}
            </Popover.Body>
        </Popover>
    );

    return (
        <>
            <OverlayTrigger overlay={popover} placement={placement} trigger={trigger}>
                <i
                    aria-label="tooltip"
                    className={`fa-light fa-info-circle ms-2 ${iconClassname} ${className}`}
                    style={{ color: tooltipColor, cursor: 'pointer' }}
                    {...otherProps}
                ></i>
            </OverlayTrigger>

        </>
    );

}
